var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvasPageDownsell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 226,
    viewBox: "0 0 178 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_424_15784)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 160,
    height: 208,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.5 11V10.9979C168.495 9.69855 167.774 8.56446 166.695 7.77225C165.616 6.97982 164.15 6.50364 162.553 6.5H162.552L15.4483 6.5L15.4471 6.5C13.8498 6.50364 12.3843 6.97982 11.3049 7.77225C10.2259 8.56447 9.50549 9.69856 9.5 10.9979H9.5V11V23V23.5H10H168H168.5V23V11Z",
    fill: "#E5E8F5",
    stroke: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 12.2402H24V18.4802H18V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 12.2402H34V18.4802H28V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 12.2402H44V18.4802H38V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 12.2402H113V18.4802H58V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 100,
    width: 17.1392,
    height: 17,
    rx: 3,
    stroke: "#4C6FFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 99,
    width: 73,
    height: 8,
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 113,
    width: 53,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 125,
    width: 17.1392,
    height: 17,
    rx: 3,
    stroke: "#4C6FFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 124,
    width: 73,
    height: 8,
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 138,
    width: 53,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 151,
    width: 17.1392,
    height: 17,
    rx: 3,
    stroke: "#4C6FFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 150,
    width: 73,
    height: 8,
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 164,
    width: 53,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 180,
    width: 122,
    height: 22,
    rx: 4,
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2539 189.801H66.543C66.5117 189.579 66.4479 189.383 66.3516 189.211C66.2552 189.036 66.1315 188.888 65.9805 188.766C65.8294 188.643 65.6549 188.549 65.457 188.484C65.2617 188.419 65.0495 188.387 64.8203 188.387C64.4063 188.387 64.0456 188.49 63.7383 188.695C63.431 188.898 63.1927 189.195 63.0234 189.586C62.8542 189.974 62.7695 190.445 62.7695 191C62.7695 191.57 62.8542 192.049 63.0234 192.437C63.1953 192.826 63.4349 193.118 63.7422 193.316C64.0495 193.514 64.4049 193.613 64.8086 193.613C65.0352 193.613 65.2448 193.583 65.4375 193.523C65.6328 193.464 65.806 193.376 65.957 193.262C66.1081 193.145 66.2331 193.003 66.332 192.836C66.4336 192.669 66.5039 192.479 66.543 192.266L68.2539 192.273C68.2096 192.641 68.099 192.995 67.9219 193.336C67.7474 193.674 67.5117 193.978 67.2148 194.246C66.9206 194.512 66.569 194.723 66.1602 194.879C65.7539 195.033 65.2943 195.109 64.7813 195.109C64.0677 195.109 63.4297 194.948 62.8672 194.625C62.3073 194.302 61.8646 193.835 61.5391 193.223C61.2161 192.611 61.0547 191.87 61.0547 191C61.0547 190.128 61.2188 189.385 61.5469 188.773C61.875 188.161 62.3203 187.695 62.8828 187.375C63.4453 187.052 64.0781 186.891 64.7813 186.891C65.2448 186.891 65.6745 186.956 66.0703 187.086C66.4688 187.216 66.8216 187.406 67.1289 187.656C67.4362 187.904 67.6862 188.207 67.8789 188.566C68.0742 188.926 68.1992 189.337 68.2539 189.801ZM76.8184 191C76.8184 191.872 76.653 192.615 76.3223 193.227C75.9941 193.839 75.5462 194.306 74.9785 194.629C74.4134 194.949 73.778 195.109 73.0723 195.109C72.3613 195.109 71.7233 194.948 71.1582 194.625C70.5931 194.302 70.1465 193.835 69.8184 193.223C69.4902 192.611 69.3262 191.87 69.3262 191C69.3262 190.128 69.4902 189.385 69.8184 188.773C70.1465 188.161 70.5931 187.695 71.1582 187.375C71.7233 187.052 72.3613 186.891 73.0723 186.891C73.778 186.891 74.4134 187.052 74.9785 187.375C75.5462 187.695 75.9941 188.161 76.3223 188.773C76.653 189.385 76.8184 190.128 76.8184 191ZM75.1035 191C75.1035 190.435 75.0189 189.958 74.8496 189.57C74.6829 189.182 74.4473 188.888 74.1426 188.688C73.8379 188.487 73.4811 188.387 73.0723 188.387C72.6634 188.387 72.3066 188.487 72.002 188.688C71.6973 188.888 71.4603 189.182 71.291 189.57C71.1243 189.958 71.041 190.435 71.041 191C71.041 191.565 71.1243 192.042 71.291 192.43C71.4603 192.818 71.6973 193.112 72.002 193.312C72.3066 193.513 72.6634 193.613 73.0723 193.613C73.4811 193.613 73.8379 193.513 74.1426 193.312C74.4473 193.112 74.6829 192.818 74.8496 192.43C75.0189 192.042 75.1035 191.565 75.1035 191ZM78.0713 187H80.1572L82.3604 192.375H82.4541L84.6572 187H86.7432V195H85.1025V189.793H85.0361L82.9658 194.961H81.8486L79.7783 189.773H79.7119V195H78.0713V187ZM88.1367 195V187H91.293C91.8997 187 92.4167 187.116 92.8438 187.348C93.2708 187.577 93.5964 187.896 93.8203 188.305C94.0469 188.711 94.1602 189.18 94.1602 189.711C94.1602 190.242 94.0456 190.711 93.8164 191.117C93.5872 191.523 93.2552 191.84 92.8203 192.066C92.388 192.293 91.8646 192.406 91.25 192.406H89.2383V191.051H90.9766C91.3021 191.051 91.5703 190.995 91.7812 190.883C91.9948 190.768 92.1536 190.611 92.2578 190.41C92.3646 190.207 92.418 189.974 92.418 189.711C92.418 189.445 92.3646 189.214 92.2578 189.016C92.1536 188.815 91.9948 188.66 91.7812 188.551C91.5677 188.439 91.2969 188.383 90.9688 188.383H89.8281V195H88.1367ZM95.2588 195V187H98.415C99.0192 187 99.5348 187.108 99.9619 187.324C100.392 187.538 100.718 187.841 100.942 188.234C101.169 188.625 101.282 189.085 101.282 189.613C101.282 190.145 101.168 190.602 100.938 190.984C100.709 191.365 100.377 191.656 99.9424 191.859C99.5101 192.062 98.9867 192.164 98.3721 192.164H96.2588V190.805H98.0986C98.4215 190.805 98.6898 190.76 98.9033 190.672C99.1169 190.583 99.2757 190.451 99.3799 190.273C99.4867 190.096 99.54 189.876 99.54 189.613C99.54 189.348 99.4867 189.124 99.3799 188.941C99.2757 188.759 99.1156 188.621 98.8994 188.527C98.6859 188.431 98.4163 188.383 98.0908 188.383H96.9502V195H95.2588ZM99.5791 191.359L101.567 195H99.7002L97.7549 191.359H99.5791ZM103.856 195H102.044L104.806 187H106.985L109.743 195H107.931L105.927 188.828H105.864L103.856 195ZM103.743 191.855H108.024V193.176H103.743V191.855ZM110.706 195V187H113.862C114.466 187 114.982 187.108 115.409 187.324C115.839 187.538 116.166 187.841 116.39 188.234C116.616 188.625 116.729 189.085 116.729 189.613C116.729 190.145 116.615 190.602 116.386 190.984C116.157 191.365 115.825 191.656 115.39 191.859C114.957 192.062 114.434 192.164 113.819 192.164H111.706V190.805H113.546C113.869 190.805 114.137 190.76 114.351 190.672C114.564 190.583 114.723 190.451 114.827 190.273C114.934 190.096 114.987 189.876 114.987 189.613C114.987 189.348 114.934 189.124 114.827 188.941C114.723 188.759 114.563 188.621 114.347 188.527C114.133 188.431 113.864 188.383 113.538 188.383H112.397V195H110.706ZM115.026 191.359L117.015 195H115.147L113.202 191.359H115.026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 42,
    width: 120,
    height: 48,
    rx: 4,
    fill: "#EDF0FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 38,
    width: 120,
    height: 48,
    rx: 3,
    stroke: "#4C6FFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6033 66.4968L99.8379 66.4968C100.666 66.4968 101.338 65.8252 101.338 64.9968L101.338 59.0117C101.338 58.1833 100.666 57.5117 99.8379 57.5117L88.6032 57.5117L88.6029 53.4788C88.6029 52.2369 87.18 51.533 86.1928 52.2866L75.0712 60.7761C74.2866 61.3751 74.2843 62.5555 75.0667 63.1574L86.1886 71.7136C87.1751 72.4725 88.6033 71.7693 88.6033 70.5248L88.6033 66.4968Z",
    fill: "white",
    stroke: "#4C6FFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9143 57.3677V68.3261C59.9143 68.7374 59.6625 69.1067 59.2796 69.257L51.6277 72.2597M59.9143 57.3677L52.6076 56.6965C52.4692 56.6838 52.3296 56.7001 52.1978 56.7444L44 59.497M59.9143 57.3677L51.6277 60.6591M44 59.497V70.2735C44 70.7696 44.3636 71.1907 44.8544 71.2629L51.6277 72.2597M44 59.497L51.6277 60.6591M51.6277 72.2597V60.6591",
    stroke: "#4C6FFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.831 62.7978V71.5728C108.831 72.0688 109.195 72.4899 109.686 72.5621L115.147 73.3659M108.831 62.7978L115.586 60.5298C115.717 60.4857 115.856 60.4694 115.994 60.4819L118.386 60.6988M108.831 62.7978L115.147 63.7601M115.147 73.3659V63.7601M115.147 73.3659L118.386 71.9955M115.147 63.7601L118.386 62.5081",
    stroke: "#4C6FFF",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.877 55.2328V69.0856C137.877 69.4969 137.625 69.8663 137.242 70.0165L127.53 73.8278M137.877 55.2328L128.701 54.3899C128.563 54.3772 128.423 54.3935 128.291 54.4377L118.005 57.8915M137.877 55.2328L127.53 59.3426M118.005 57.8915V71.5625C118.005 72.0586 118.369 72.4796 118.86 72.5519L127.53 73.8278M118.005 57.8915L127.53 59.3426M127.53 73.8278V59.3426",
    stroke: "#4C6FFF",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 6.5,
    width: 159,
    height: 207,
    rx: 5.5,
    stroke: "#D0D4E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_424_15784",
    x: 0,
    y: 0,
    width: 178,
    height: 226,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_424_15784"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_424_15784"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_424_15784",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasPageDownsell);
export default __webpack_public_path__ + "static/media/canvas_page_downsell.b089cd05f0401bf28f629fffc76fb2ac.svg";
export { ForwardRef as ReactComponent };